export const getters = {
  getStages($state) {
    return Object.values($state.records).sort(
      (a, b) => a.position - b.position || a.id - b.id
    );
  },
  getStageById: $state => id => $state.records[id] || null,
  getUIFlags($state) {
    return $state.uiFlags;
  },
};
